const SET_CASH_IS_VISIBLE = 'SET_CASH_IS_VISIBLE';

export { SET_CASH_IS_VISIBLE };



// WEBPACK FOOTER //
// ./src/containers/Inputs/CASH/constants.js